// Single source of truth for portfolio projects (used by Home and Work pages)
export const projectData = [
    {
      name: "Ticket Central",
      category: "Lifestyle & Learning",
      figma: "https://www.figma.com/file/Gp2XRsJNvZQFQpQ55vKskU/Ticket-Central-Changes?type=design&node-id=0-1&mode=design&t=KBpsRcwZni5QCbrc-0",
      appStore: "https://apps.apple.com/pk/app/ticketcentral/id6477536780",
      playStore: "https://play.google.com/store/apps/details?id=com.ticketcentralapp&pcampaignid=web_share"
    },
    {
      name: "Face Yoga TG",
      category: "Health & Wellness",
      figma: "https://www.figma.com/design/OqFKQOLluE1DbXbf8BGdoE/Face-Yoga-TG-(Production-File-)?node-id=1%3A3&t=31bwEthsLOg98Xgu-1",
      appStore: "https://apps.apple.com/at/app/face-yoga-tg/id6504173004",
      playStore: "https://play.google.com/store/apps/details?id=com.face_yoga&hl=en"
    },
    {
      name: "Wolo",
      category: "Lifestyle & Learning",
      figma: "https://www.figma.com/proto/fjGwrscihDvWXLrEObOxmz/wolo?type=design&node-id=498-11743&scaling=scale-down&page-id=1%3A2&starting-point-node-id=498%3A6266",
      appStore: "https://apps.apple.com/pk/app/wolo-app/id6468480778",
      playStore: "https://play.google.com/store/apps/details?id=com.tx.wolo&pcampaignid=web_share"
    },
    {
      name: "Wave-Makers",
      category: "Lifestyle & Learning",
      figma: "https://www.figma.com/design/Cq0l8DdDasud1t9Pkc8J8W/PICK'T-Up?type=design&node-id=1%3A3&mode=design&t=ughaYeQmkNIIoRRa-1", // Placeholder figma link if not provided
      appStore: "https://apps.apple.com/pk/app/wave-makers/id1664854004"
    },
    {
      name: "Think Instead",
      category: "Health & Wellness",
      figma: "https://www.figma.com/file/8YOxOijvtZFfCkrh5fq5MR/Think-Instead?type=design&node-id=0-1&t=zuxpIUsxWFXo30kg-0",
      appStore: "https://apps.apple.com/pk/app/think-instead/id6450711425",
      playStore: "https://play.google.com/store/apps/details?id=com.thinkinsteadandroid&pcampaignid=web_share"
    },
    {
      name: "DriveBuddyz",
      category: "Mobility & Logistics",
      figma: "https://www.figma.com/file/09Dj5zlyuZg0P75XlxD4q3/Drive-Buddyz?node-id=0%3A1&t=SSSoQva9VfkscvD5-1",
      appStore: "https://apps.apple.com/pk/app/drive-buddyz/id6451443805",
      playStore: "https://play.google.com/store/apps/details?id=com.drivebuddyz&pcampaignid=web_share"
    },
    {
      name: "Vidunderlig",
      category: "Lifestyle & Learning",
      figma: "https://www.figma.com/design/GOxxptxG4cmriBH3g8SY9o/Khadmatuk?node-id=1-3&t=jcBY8rXjlBd9m8oA-0",
      appStore: "https://apps.apple.com/pk/app/vidunderlig/id6453559072",
      playStore: "https://play.google.com/store/apps/details?id=com.vidunderlig&pcampaignid=web_share"
    },
    {
      name: "Descubrelo Colorado",
      category: "Lifestyle & Learning",
      figma: "https://www.figma.com/design/GOxxptxG4cmriBH3g8SY9o/Khadmatuk?node-id=1-3&t=jcBY8rXjlBd9m8oA-0",
      appStore: "https://apps.apple.com/pk/app/descubrelo-colorado/id6468779966",
      playStore: "https://play.google.com/store/apps/details?id=com.descubrelo.app&pcampaignid=web_share"
    },
    {
      name: "Pick'tup",
      category: "Mobility & Logistics",
      figma: "https://www.figma.com/file/Cq0l8DdDasud1t9Pkc8J8W/PICK'T-Up?type=design&node-id=1%3A3&mode=design&t=ughaYeQmkNIIoRRa-1",
      appStore: "https://apps.apple.com/pk/app/picktup/id6478540852",
      playStore: "https://play.google.com/store/apps/details?id=com.tx.picktup&pcampaignid=web_share"
    },
    {
      name: "SED-User",
      category: "Mobility & Logistics",
      figma: "https://www.figma.com/design/gTLPGEMNMuA0cDIWUn495n/Haulcat?node-id=2-31&t=Wm4xbMUBIPkxZNoo-0",
      playStore: "https://play.google.com/store/apps/details?id=com.tx.sed&pcampaignid=web_share"
    },
    {
      name: "The designated App",
      category: "Mobility & Logistics",
      figma: "https://www.figma.com/design/2KKnaAkxpX7XdNiwL5sNSK/The-designated-Application?node-id=916-13042&t=4gTjCpHB32s1KnkO-1",
      appStore: "https://apps.apple.com/pk/app/designated-bahamas/id6471088426",
      playStore: "https://play.google.com/store/apps/details?id=com.thedesignatedapp"
    },
    {
      name: "Fotofetti",
      category: "Social & Communication",
      figma: "https://www.figma.com/design/0G593ggHghtHy24dRNawgR/Snap-Fetti-new-design-file?t=KpwKYefCnrn2H561-0",
      appStore: "https://apps.apple.com/pk/app/fotofetti/id6738360983",
      playStore: "https://play.google.com/store/apps/details?id=com.tx.fotofetti&pcampaignid=web_share"
    },
    {
      name: "Kavan",
      category: "Health & Wellness",
      figma: "https://www.figma.com/file/VH1Qyc85TVUwYP96T8TNh6/Mindmatch?type=design&node-id=0-1&t=LVCTafSxbuoeMYY1-0",
      appStore: "https://apps.apple.com/pk/app/kavan/id6448465046",
      playStore: "https://play.google.com/store/apps/details?id=com.kavan&pcampaignid=web_share"
    },
    {
      name: "Paisero",
      category: "Lifestyle & Learning",
      figma: "https://www.figma.com/file/xJDUoljYxDYt5nxCa20x9p/Urushare?type=design&node-id=315%3A132&t=9zu3sjiTexjUtIyr-1",
      appStore: "https://apps.apple.com/pk/app/paisero/id6477383823",
      playStore: "https://play.google.com/store/apps/details?id=com.tx.paisero&pcampaignid=web_share"
    },
    {
      name: "Sit",
      category: "Lifestyle & Learning",
      figma: "https://www.figma.com/file/U9dqJiLhiPOSAkbdoatcPc/Sit-App.?type=design&node-id=0%3A1&t=0RNqa6oNdaPXApPI-1",
      appStore: "https://apps.apple.com/pk/app/sit-app/id6452016916",
      playStore: "https://play.google.com/store/apps/details?id=com.tx.sit&pcampaignid=web_share"
    },
    {
      name: "Prosearch",
      category: "Mobility & Logistics",
      figma: "https://www.figma.com/design/ZFPIQL1hKtqWSnj5LeSuFk/Atlas-Cars?node-id=130-4385&t=vk9RSjYQdOsdd5GR-1",
      appStore: "https://apps.apple.com/pk/app/prosearch/id6458977843",
      playStore: "https://play.google.com/store/apps/details?id=com.prosearch&pcampaignid=web_share"
    },
    {
      name: "Pinolo",
      category: "Mobility & Logistics",
      figma: "https://www.figma.com/file/YP7P3ycMtuVAtG0XoGMpJs?node-id=0:1",
      playStore: "https://play.google.com/store/apps/details?id=com.pinolo.app&pcampaignid=web_share"
    },
    {
      name: "Haulcat - User App",
      category: "Mobility & Logistics",
      figma: "https://www.figma.com/design/gTLPGEMNMuA0cDIWUn495n/Haulcat?node-id=2-31&t=Wm4xbMUBIPkxZNoo-0",
      playStore: "https://play.google.com/store/apps/details?id=com.haulcat.haulcatuser&pcampaignid=web_share"
    },
    {
      name: "Haulcat - Delivery App",
      category: "Mobility & Logistics",
      figma: "https://www.figma.com/design/gTLPGEMNMuA0cDIWUn495n/Haulcat?node-id=2-31&t=Wm4xbMUBIPkxZNoo-0",
      playStore: "https://play.google.com/store/apps/details?id=com.haulcat.delivery&pcampaignid=web_share"
    },


    // Non-live or Figma only projects
    { name: "Astra Collection", category: "Social & Communication", figma: "https://www.figma.com/proto/wmSkcwp55xGIMyy3Mvmdth/Astra-collective?type=design&node-id=2-74&t=fcJfVSyBph8tSidT-0&scaling=scale-down&starting-point-node-id=2%3A66" },
    { name: "Arab ma Arab", category: "Social & Communication", figma: "https://www.figma.com/file/6k1JHpRxvc2UMNmFxhE0tp/Arab-ma-Arab?node-id=1%3A2&t=LeFrczcu9LLcl7U4-1" },
    { name: "Carnet", category: "Mobility & Logistics", figma: "https://www.figma.com/design/UnW9mH4pV6cF5XpUG96Wom/Carnet-new-design-file?node-id=163-13573&node-type=frame&t=yrb2rLAAufhGZ0DW-0" },
    { name: "Cabz App", category: "Mobility & Logistics", figma: "https://www.figma.com/file/HSYBkBjyLpG1kXji4AQjl8/Cabz-App?type=design&node-id=1%3A3&mode=design&t=iKZ2mCG7httMiJns-1" },
    { name: "Atlas Cars", category: "Mobility & Logistics", figma: "https://www.figma.com/design/ZFPIQL1hKtqWSnj5LeSuFk/Atlas-Cars?node-id=130-4385&t=vk9RSjYQdOsdd5GR-1" },
    { name: "Bus Connect", category: "Mobility & Logistics", figma: "https://www.figma.com/file/blQ8rlkDCLGq3Tbxy44lGk/BusConnect?type=design&node-id=1-2&mode=design&t=sqDOKH2R96c3npYk-0" },
    { name: "Sharecipe", category: "Lifestyle & Learning", figma: "https://www.figma.com/file/5XYKasuIV9xfwJcDaGuRwL/Sharecipe-app?type=design&node-id=1-1379&t=k8QhczFeiaae3moM-0" },
    { name: "Furvana", category: "Lifestyle & Learning", figma: "https://www.figma.com/file/mT1uyelQzEdbXbPM5hg7vY/Furvana?type=design&node-id=1%3A2&mode=design&t=L8TuI41aD0zLNG3d-1" },
    { name: "Khadmatuk", category: "Lifestyle & Learning", figma: "https://www.figma.com/design/GOxxptxG4cmriBH3g8SY9o/Khadmatuk?node-id=1-3&t=jcBY8rXjlBd9m8oA-0" },
    { name: "Bachata", category: "Lifestyle & Learning", figma: "https://www.figma.com/file/O6uUOvB05GrngXliXIsLbp/Bachata-mobile-app?type=design&node-id=1%3A3&mode=design&t=s6Jhto5gaTONR794-1" },
];

export const categories = ["All", "Health & Wellness", "Mobility & Logistics", "Social & Communication", "Lifestyle & Learning"];
